import { Action } from 'redux'
import { NotificationActions } from '../../reducers/userAccount/actionNames'

const markNotificationAsRead = (
  id: number | number[],
): INotificationMarkAsRead => ({
  id,
  type: NotificationActions.MarkAsRead,
})

export interface INotificationMarkAsRead
  extends Action<NotificationActions.MarkAsRead> {
  id: number | number[]
}

const markNotificationAsSeen = (
  id: number | number[] | 'all',
  force = false,
): INotificationMarkAsSeen => ({
  force,
  id,
  type: NotificationActions.MarkAsSeen,
})

export interface INotificationMarkAsSeen
  extends Action<NotificationActions.MarkAsSeen> {
  force: boolean
  id: number | number[] | 'all'
}

const deleteNotification = (
  id: number | number[] | 'all',
): INotificationDelete => ({
  id,
  type: NotificationActions.Delete,
})

const reloadNotifications = (
  notifications,
  hasMore = false,
): INotificationReload => ({
  hasMore,
  notifications,
  type: NotificationActions.Reload,
})

export interface INotificationReload
  extends Action<NotificationActions.Reload> {
  hasMore: boolean
  notifications: any // temp
}

export interface INotificationDelete
  extends Action<NotificationActions.Delete> {
  id: number | number[] | 'all'
}

export {
  reloadNotifications,
  markNotificationAsRead,
  markNotificationAsSeen,
  deleteNotification,
}
